import { render, staticRenderFns } from "./SidebarEditProfile.vue?vue&type=template&id=1a12126d&scoped=true"
import script from "./SidebarEditProfile.vue?vue&type=script&lang=js"
export * from "./SidebarEditProfile.vue?vue&type=script&lang=js"
import style0 from "./SidebarEditProfile.vue?vue&type=style&index=0&id=1a12126d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a12126d",
  null
  
)

export default component.exports